import React from 'react';

export const facebookIcon = () => {
  return (
    <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.000181964 18.0017C-0.0441045 27.8381 8.00128 35.9886 17.7968 36.0345C27.8564 36.0821 35.9592 28.0857 35.9985 18.0739C36.0396 8.22933 28.027 0.129663 18.1708 0.0345459H17.9362C8.06196 0.0657048 0.0444685 8.07682 0.000181964 18.0017ZM13.4534 14.0856H15.3381C15.3381 13.5034 15.3315 12.9704 15.3381 12.4374C15.3791 9.6774 16.8766 8.19326 19.6257 8.1867C20.5524 8.18506 21.4791 8.1867 22.4862 8.1867V11.5879C21.8203 11.5879 21.1954 11.6043 20.5721 11.583C19.8126 11.5584 19.4584 11.9061 19.483 12.6637C19.4977 13.095 19.4862 13.5263 19.4862 14.0642H22.6027C22.4797 15.4172 22.3665 16.6586 22.2468 17.9919H19.3763V27.8201H15.3758V18.0739H13.4518V14.0839L13.4534 14.0856Z"
        fill="#CACACC"
      />
    </svg>
  );
};
